import React, { useEffect, useRef } from "react";
import gsap from "gsap";

const ContactButton = () => {
  const btnRef = useRef(null);
  const wrapRef = useRef(null);

  useEffect(() => {
    gsap.fromTo(
      wrapRef.current,
      { opacity: 0, y: 15 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power3.out", delay: 2.6 }
    );
  }, []);

  useEffect(() => {
    const btn = btnRef.current;
    if (!btn) return;

    const isTouch = window.matchMedia(
      "(hover: none) or (pointer: coarse)"
    ).matches;
    if (isTouch) return;

    const handleMove = (e) => {
      const rect = btn.getBoundingClientRect();
      const x = e.clientX - rect.left - rect.width / 2;
      const y = e.clientY - rect.top - rect.height / 2;
      gsap.to(btn, {
        x: x * 0.25,
        y: y * 0.25,
        duration: 0.35,
        ease: "power2.out",
      });
    };

    const handleLeave = () => {
      gsap.to(btn, {
        x: 0,
        y: 0,
        duration: 0.6,
        ease: "elastic.out(1, 0.4)",
      });
    };

    btn.addEventListener("mousemove", handleMove);
    btn.addEventListener("mouseleave", handleLeave);
    return () => {
      btn.removeEventListener("mousemove", handleMove);
      btn.removeEventListener("mouseleave", handleLeave);
    };
  }, []);

  return (
    <div ref={wrapRef} className="mt-14 md:mt-20 opacity-0">
      <a
        ref={btnRef}
        href="mailto:hello@orbitalworks.net"
        className="group relative inline-flex items-center gap-3 px-8 py-4 rounded-full border border-white/[0.08] hover:border-brand-accent/30 bg-white/[0.02] hover:bg-brand-accent/[0.05] transition-all duration-500 cursor-none"
        data-hover
      >
        <span className="font-sans text-xs md:text-[13px] font-semibold tracking-[0.2em] uppercase text-brand-cream/50 group-hover:text-brand-accent transition-colors duration-400">
          Start a project
        </span>
        <svg
          className="w-4 h-4 text-brand-cream/20 group-hover:text-brand-accent group-hover:translate-x-1 transition-all duration-400"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>

        <div className="absolute inset-0 rounded-full bg-brand-accent/0 group-hover:bg-brand-accent/[0.03] blur-xl transition-all duration-700 pointer-events-none" />
      </a>
    </div>
  );
};

export default ContactButton;